<template>
    <section class="flex flex-col sm:px-3 lg:px-28 sm:py-12 py-32 text-center background w-full h-full">
        <div class="w-full justify-center flex">
            <h2 class="font-semibold mt-14 sm:mt-24 mb-14 w-max">
                {{ title }}
            </h2>
        </div>

        <ClientOnly>
            <div class="flex flex-wrap w-full justify-center">
                <div v-for="(customerChunk, index) in getChunkClass" :key="index"
                    class="justify-center items-center gap-2 h-auto w-auto sm:max-w-full xl:max-3/4 lg:max-w-3/4">
                    <Testimonial v-for="customer of customerChunk" :name="customer.name" :quote="customer.quote"
                        :position="customer.position" :image_url="customer.image_url" :total="String(customers?.length)"
                        :image_40="customer.image_40" class="mb-4 mx-2 relative dark-gray rounded-lg py-4 px-4" />
                </div>
            </div>


        </ClientOnly>

        <a href="https://www.g2.com/products/unified-to/reviews" target="_blank"
            class="flex items-center text-gray-200 my-8 w-full justify-center text-lg">
            <Icon name="simple-icons:g2" class="w-8 h-8 mr-2 " style="color: #FF492C" />
            <Icon name="mdi:star" class="w-6 h-6" />
            <Icon name="mdi:star" class="w-6 h-6" />
            <Icon name="mdi:star" class="w-6 h-6" />
            <Icon name="mdi:star" class="w-6 h-6" />
            <Icon name="mdi:star" class="w-6 h-6 mr-4" />
            <span class="border-l px-4 border-white">5 stars on <strong>G2</strong></span>
        </a>
    </section>
</template>

<script lang="ts">
const CUSTOMERS: { name: string; position: string; quote: string; image_url?: string; image_40?: boolean }[] = [
    {
        name: 'Oz L.',
        position: 'CEO, RunFutureProof',
        quote: 'After using Merge, Codat, and Rutter in two prior companies, Unified is the clear standout: richer integrations, a pricing model you can actually scale with, and service that delivers. A true tech hat trick.',
        image_url: '/images/customers/oz.webp',
    },
    {
        name: 'Kevin K.',
        position: 'CEO, Humi',
        quote: 'Unified is impressively fast at responding to our integration requests and adding them within days. Humi is on a mission to become the ultimate streamlined HRIS platform for Canadians, and offering direct integrations through Unified brings tremendous value to our customers.',
        image_url: '/images/customers/Kevin+Kliman+Humi.webp'
    },
    {
        name: 'Timothy S.',
        position: 'Senior Engineer, Humi',
        quote: `I am very impressed with Unified. Their team is highly responsive, and their support is top-notch. Their dashboard is powerful and allows us to easily observe the health of our connections.`,
        image_url: '/images/customers/Timothy+Stoyanovski+Humi.jpg'
    },
    {
        name: 'Yuma H.',
        position: 'CEO, HeroHunt.ai',
        quote: `Unified has a great variety of available API integrations. The dev team is quick to add new features and connections. With Unified, we can make a lot more API integrations available to our customers.`,
        image_url: '/images/customers/Yuma+Heymans+HeroHunt.jpg'
    },
    {
        quote: 'The Unified team was incredibly responsive during our integration phase, quickly delivering the functionality and integrations we needed. The solution is robust and comprehensive, perfectly addressing our use case. The team is very knowledgeable and provided extensive support and expertise to our engineers.',
        name: 'Stjepan B.',
        position: 'CIO & Co-founder, Cognism',
        image_url: '/images/customers/stjepan.webp'
    },
    {
        name: 'Brian S.',
        position: 'CEO, Sync2Hire',
        quote: `Unified excels at simplifying multi-ATS integrations, allowing our customers to swiftly retrieve necessary data from their ATS into our platform to maintain compliance. Their team is exceptionally responsive and continually enhances their service by adding new integrations and features, ensuring an ever-improving experience for both our team and our customers.`,
        image_url: '/images/customers/Brian+Sherlock+Chat+Technologies.jpg'
    },
    {
        name: 'Lucian S.',
        position: 'CTO, HeroHunt.ai',
        quote: `Integrating with Unified was super easy. We developed a generic setup on our end and every time we want to enable any ATS integration the only thing we need to do is to enable it in the Unified dashboard. This is very efficient as we do not need to make any code changes or new releases.`,
        image_url: '/images/customers/Lucian+Simo+HeroHunt.webp'
    },
    {
        name: 'Bijan V.',
        position: 'Founder & CEO, ProductShots',
        quote: 'Unified has been exceptional in providing hands-on support for implementing their software. The one-on-one support and direct line of communication have made the process seamless and efficient. Their unified data model makes sense and is flexible for our integration needs. Couldn\'t ask for a better partner when launching our integration featureset!',
        image_url: '/images/customers/Bijan+V+Hubspot.jpeg'
    },
    {
        name: 'Mike K.',
        position: 'Co-founder, Mycroft',
        quote: 'Our team has been able to build and integrate with 15 products on an Alpha-stage product and we expect to be launching with over 150 integrations for our public launch. This is a truly unified API platform, not a pretty UI passthrough where you\'d still end up building the same integrations yourself.',
        image_url: '/images/customers/Mike+Kim+MyCroft.jpeg'
    },
    {
        name: 'Raj T.',
        position: 'Co-founder, Boondoggle AI',
        quote: 'Unified has allowed us to connect to our client\'s CRMs, enterprise software, and messaging platforms faster than ever before which allows us to spend more time on tasks that provide value to our clients. Their customer support is extremely responsive and comes at a price that is hard to beat within the industry!',
        image_url: '/images/customers/Raj+Thaker+BoondoggleAI.jpeg'
    },
    // {
    //     name: 'John B.',
    //     position: 'Founder, RecView',
    //     quote: `We are looking at ways to get our integrations done quickly, especially for some smaller ATS/CRMs. The team has been amazing, adding endpoints that we need and coming back super quick. Also, you won't get a better price. Some competitors were charging upwards of 30k just for a platform fee like it was the 90s.`,
    //     image_url: '/images/customers/John+B.png'
    // },
    {
        name: 'Jlil Abdejlil',
        position: 'Engineering, Elly.ai',
        quote: 'Just want to reiterate our appreciation here, Unified team! You all are a critical partner for our product roadmap and the speed at which you all address our blockers is a lifesaver.',
        image_url: '/images/jlil.webp'
    },
    {
        name: 'Faisal Abid',
        position: 'CTO, Interstellar Labs',
        quote: 'You know what is the best thing about Unified.to? It\'s boring! Like it just works and I can focus on actually building my stuff.',
        image_url: '/images/faisal.webp'
    },
    {
        name: 'Jordan O.',
        position: 'CEO, Neslo',
        quote: 'A huge shoutout to the Unified team for the quick turnaround time and the overall experience with the platform. It has been great and we appreciated the amazing support.',
        image_url: '/images/jordanolsen.jpeg',
    },
    {
        name: 'Daniil L.',
        position: 'AI Specialist',
        quote: 'Our integration journey and overall experience with your service were very smooth. We encountered no issues, and everything functioned seamlessly.',
        image_url: '/images/daniil.webp'
    },
    {
        name: 'Anton Zaides',
        position: 'Engineering Manager, HoneyBook',
        quote: 'The responsiveness from Unified and the willingness to adapt to what we needed stood out. It\'s the best turnaround I\'ve seen on requests and questions.',
        image_url: '/images/customers/anton.webp'
    }

    // {
    //     name: 'Fasial Abid',
    //     position: 'CTO, Interstellar Labs',
    //     quote: 'I demoed my application to a customer and they asked if we could add Intercom as a connector, to which I just said "ok sure" and went and activated it in Unified.to. It magically showed up in my application and they were blown away by the speed.',
    //     image_url: '/images/faisal.webp'
    // }
];

export default {
    props: {
        limit: {
            type: Number,
            default: null
        },
        title: {
            type: String,
            default: 'Why our customers choose us'
        }
    },
    data() {
        return {
            customers: CUSTOMERS,
            // Avoid SSR ReferenceError: window is not defined
            screenSize: typeof window !== 'undefined' ? window.innerWidth : 1200,
        };
    },

    computed: {
        getChunkClass() {
            if (this.screenSize < 675) {
                return [this.shuffleAndRearrangeTestimonials()];
            } else if (this.screenSize < 1200) {
                return this.customerChunks(2);
            } else {
                return this.customerChunks(3);
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    created() {
        if (this.limit) {
            const shuffled = [...CUSTOMERS].sort(() => 0.5 - Math.random());
            this.customers = shuffled.slice(0, this.limit);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.screenSize = window?.innerWidth;
        },
        customerChunks(limit: number = 3) {
            const customers = this.customers || [];
            if (customers.length === 0) return [];
            const sortedCustomers = [...customers].sort((a, b) => a.quote.length - b.quote.length);

            const chunks: Array<typeof sortedCustomers> = Array.from({ length: limit }, () => []);
            const chunkLengths = Array(limit).fill(0);

            sortedCustomers.forEach(customer => {
                const minIndex = chunkLengths.indexOf(Math.min(...chunkLengths));
                chunks[minIndex]?.push(customer);
                chunkLengths[minIndex] += customer.quote.length;
            });

            return chunks;
        },

        shuffleAndRearrangeTestimonials() {
            if (this.customers === undefined) return [];
            const customers = this.customers;
            const companies: any = {};
            customers.forEach((customer: any) => {
                const positionStr = (customer?.position || '');
                const parts = positionStr.split(',');
                const company = ((parts[1] || '').trim()) || 'Other';
                if (!companies[company]) {
                    companies[company] = [];
                }
                companies[company].push(customer);
            });

            const groups = Object.values(companies);
            const result: any = [];
            const maxGroupSize = Math.max(...groups.map((group: any) => group.length));

            for (let i = 0; i < maxGroupSize; i++) {
                groups.forEach((group: any) => {
                    if (group[i]) {
                        result.push(group[i]);
                    }
                });
            }

            return result;
        }
    },
}


</script>